export const MuiFormLabel = {
  asterisk: {
    color: 'red',
    '&$error': {
      color: 'red'
    }
  }
}
